import axios from "axios";
import { messageService } from "./services/subscriberService";
import { env, CheckValue } from "./services/CommonFunction";
import { getWhiteLabelData } from "./services/Constants";

const instance = axios.create({
  baseURL: env("Urls"),
});

instance.interceptors.request.use(
  (request) => {
    if (messageService.show) {
      messageService.sendMessage(true);
    } else {
      messageService.show = true;
    }
    let token = localStorage.getItem("accessToken");
    if (token) {
      request.headers.access_token = token;
    }
    const whiteLabelData = getWhiteLabelData();
    if (whiteLabelData.isWhiteLabeled) {
      request.headers.app_id = whiteLabelData.appID;
    }
    return request;
  },
  (error) => {
    console.error(error);
    messageService.sendMessage(false);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (response.headers["latest-coach-panel"] === "false") {
      if (localStorage.getItem("latest-coach-panel")) {
      } else {
        localStorage.setItem("latest-coach-panel", "false");
        window.location.reload(true);
      }
    } else if (response.headers["latest-coach-panel"] === "true") {
      if (localStorage.getItem("latest-coach-panel")) {
        setTimeout(() => {
          localStorage.removeItem("latest-coach-panel");
        }, 10000);
      }
    }
    messageService.sendMessage(false);
    return response;
  },
  (error) => {
    messageService.sendMessage(false);
    return Promise.reject(error);
  }
);

instance.defaults.headers.common["content-language"] = "en";

export default instance;
